import { NavItem } from '@billy/design-system'
import { TFunction } from 'i18next'

import { Account } from '@modules-deprecated/app/accounts/types'

import { BankAccountStatus } from '../../../enums/bankAccountStatus'
import { BankAccount } from '../../../types/bankAccount'
import { BankAccountValue } from '../types/bankAccountValue'
import { getDisplayTitle } from './getDisplayTitle'

interface GetItemParams {
  account: Account
  bankAccountDetails?: BankAccount
  t: TFunction
}

const getItem = ({ account, bankAccountDetails, t }: GetItemParams): NavItem<BankAccountValue> => {
  const { accountNo, description, id, name } = account
  const isClosedBankAccount = bankAccountDetails?.status === BankAccountStatus.CLOSED
  const displayTitle = getDisplayTitle({ account, isClosed: isClosedBankAccount, t })
  const displayDescription = description
  const searchKeywords = [name.toString()]

  if (description) {
    searchKeywords.push(...description.split(' '))
  }

  if (accountNo) {
    searchKeywords.push(accountNo.toString())
  }

  return {
    id,
    children: displayTitle,
    searchKeywords,
    value: {
      ...account,
      displayData: {
        title: displayTitle,
        description: displayDescription,
      },
    },
  }
}

export const getItems = (
  activeBookkeepingAccounts: Account[],
  bankAccounts: BankAccount[],
  t: TFunction,
): NavItem<BankAccountValue>[] => {
  return activeBookkeepingAccounts.map((account) => {
    const bankAccountDetails = bankAccounts.find((bankAccount) => bankAccount.bookkeepingAccountId === account.id)
    const item = getItem({ account, bankAccountDetails, t })
    return item
  })
}
